export default "__VITE_ASSET__CuxtLq2n__"